import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Revel } from '../../models/revel';

@Component({
  selector: 'app-revel-dialog',
  templateUrl: './revel-dialog.component.html',
  styleUrls: ['./revel-dialog.component.scss'], // Updated to .scss
  standalone: false
})
export class RevelDialogComponent {
  editForm: FormGroup;
  viewMode: boolean;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RevelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { revel: Revel | null; viewMode: boolean }
  ) {
    this.viewMode = data.viewMode;
    this.editForm = this.fb.group({
      id: [data.revel?.id || 0],
      revelName: [data.revel?.revelName || ''],
      revelDate: [data.revel?.revelDate ? new Date(data.revel.revelDate) : null], // Ensure revelDate is a Date object
      revelLocation: [data.revel?.revelLocation || ''],
      revelType: [data.revel?.revelType || ''],
      isPublic: [data.revel?.isPublic || false],
      comments: [data.revel?.comments || '']
    });
  }

  saveChanges(): void {
    if (this.editForm.valid) {
      const revelData = {
        ...this.editForm.value,
        revelDate: this.editForm.value.revelDate
          ? this.formatDate(this.editForm.value.revelDate) // Format date as YYYY-MM-DD
          : null
      };
      this.dialogRef.close(revelData);
    }
  }

  private formatDate(date: Date): string {
    // Extract the date part and format it as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }
}
